class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
clearTimeout(this.ffAutoCloseTimer);

const isMobile = window.matchMedia('(max-width: 749px)').matches;
const autoCloseDelay = isMobile ? 6500 : 5000;

this.ffAutoCloseTimer = setTimeout(() => {
  this.close();
}, autoCloseDelay);
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);

      if (!elementToReplace || !parsedState.sections || !parsedState.sections[section.id]) {
        return;
      }

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.updateCustomCartCount();

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
    ];
  }

    getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  updateCustomCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll('a[href="/cart"]').forEach((link) => {
          const text = link.textContent.trim().toLowerCase();

          if (text.startsWith('cart')) {
            link.textContent = `Cart(${cart.item_count})`;
          }

          const mobileBubble = link.querySelector('[class*="ff-mobile-cart-count"]');
          const mobileWrap = link.querySelector('[class*="ff-mobile-cart-icon-wrap"]');

          if (mobileBubble) {
            mobileBubble.textContent = cart.item_count;
          } else if (mobileWrap && cart.item_count > 0) {
            const bubble = document.createElement('span');
            bubble.className = 'ff-mobile-cart-count';
            bubble.textContent = cart.item_count;
            mobileWrap.appendChild(bubble);
          }
        });
      });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
